export default "__VITE_ASSET__93HQmITN__"